export default __webpack_public_path__ + "static/media/user.091a9732.png";